import type { Option } from '@ksyos/design-system';
import { translateKey } from '@frontend/translate';

export function enumToDropdownIOptions(jsEnum: { [s: number]: string }, translateKeyRoot: string): Option[] {
    const result: Option[] = Object.values(jsEnum).map((item) => {
        return { value: item, label: translateKey(`${translateKeyRoot}.${item}`) };
    });

    return result;
}
